import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortenText',
    standalone: true
})
export class ShortenTextPipe implements PipeTransform {
  transform(v?: string, chars: number = 100): string {
    if (! v) return ''
    const trail = '...'
    return v.length > chars ? v.substring(0, chars) + trail : v
  }
}
